// Input kinds and the format a new input starts at, apart from the forms'
// context (which needs the browser) so they test in node.

export const ipKinds = ['srt_listener', 'srt_caller', 'rtmp_listener', 'rtmp_pull', 'url', 'udp', 'rist']

// the kinds whose new inputs follow their source: IP feeds, media files,
// NDI and DeckLink. The rest have no source to follow (the test pattern, a
// multiview, an audio input's black) or never follow its rate (a caster)
export const autoKinds = [...ipKinds, 'media', 'ndi', 'decklink']

// the format a new input of this kind starts at: auto (following its
// source), so a 720p feed is not scaled up to a fixed 1080p on every
// frame; the other kinds at 1080p59.94, what nearly every input is
// (DECISIONS 2026-10-17 "new inputs follow their source")
export function newInputFormat(kind: string): { width: number; height: number; fps: string } {
    return autoKinds.includes(kind)
        ? { width: 0, height: 0, fps: '' }
        : { width: 1920, height: 1080, fps: '60000/1001' }
}
